import { FC } from 'react';

import { ic_credit_card, ic_credit_card_primary } from '.';

const CreditCardIcon: FC<{ width?: number; primary?: boolean }> = ({ width = 24, primary }) => {
  if (primary) {
    return <img src={ic_credit_card_primary} width={width} alt="" />;
  }
  return <img src={ic_credit_card} width={width} alt="" />;
};

export default CreditCardIcon;
